import { Application } from '@/types/application';
import { Detail, emptyValue } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { KeyValue, VariableRef } from '@/types/variable';
import { isArray, isObject } from '@/util/typeGuards';
import { variableUtil } from './variable';

export const kvVariablesListUtil = (): ValidationObject<KeyValue<VariableRef | emptyValue>[] | undefined> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const variables = getValue(configuration, details);
    if (configuration.required && variables === undefined) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing required variables: ${configuration.label}`,
        id: nodeId
      });
    }
    if (variables?.length) {
      const validatedVars = variables
        .map((variable) =>
          variableUtil().validate(
            application,
            metadata,
            linkedSubroutineId,
            nodeId,
            blockName,
            configuration,
            variable.value
          )
        )
        .flat();
      if (validatedVars.length) {
        errors.push(...validatedVars);
      }
    }
    return errors;
  };

  const getValue = (configuration: Configuration, obj: unknown): KeyValue<VariableRef | emptyValue>[] | undefined => {
    if (!obj) return;
    const initVal = obj;
    if (isArray(initVal)) {
      return initVal.map((value) => ({ key: value.key || '', value: value.value || {} }));
    } else if (isObject(obj)) {
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate,
    getValue
  };
};
